import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'
import * as Yup from 'yup'

const validationFormik = Yup.object({
  dsNome: Yup.string().required('Campo Obrigatório!'),
})

const retornoAutorizacaoAcesso = (u = []) => ({
  idAutorizacaoAcesso: u?.[0] || undefined,
  dsNome: u?.[1] || undefined,
  dsMotivoAcesso: u?.[4] || undefined,
})
const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornoAutorizacaoAcesso(dados)}
      validationSchema={validationFormik}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                size="small"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsMotivoAcesso"
                label="Motivo Acesso"
                fullWidth
                rows={4}
                multiline
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default Edicao
